import React from "react";

/**
 * Renders a gallery of 1 big image and 2 smaller ones below it, with a clickable image expander.
 * @param {*} props 
 * @returns 
 */
function OnePlusTwoGallery(props) {
    return (
        <div uk-lightbox="animation: fade">
            <div className="uk-grid-small uk-child-width-1-1 uk-grid-match" data-uk-grid>
                <div>
                    <a className="uk-inline" href={props.BigImageLink} data-caption={props.BigImageDescription}>
                        <img
                            src={props.BigImageLink}
                            alt={props.BigImageDescription}
                            className="uk-border-rounded uk-box-shadow-large"
                        />
                    </a>
                </div>

                <div className="uk-margin-top">
                    <div className="uk-grid-small uk-child-width-1-2@s" data-uk-grid>
                        <div>
                            <a className="uk-inline" href={props.SmallImage1Link} data-caption={props.SmallImage1Description}>
                                <img
                                    src={props.SmallImage1Link}
                                    alt={props.SmallImage1Description}
                                    className="uk-border-rounded uk-box-shadow-small"
                                />
                            </a>
                        </div>
                        <div>
                            <a className="uk-inline" href={props.SmallImage2Link} data-caption={props.SmallImage2Description}>
                                <img
                                    src={props.SmallImage2Link}
                                    alt={props.SmallImage2Description}
                                    className="uk-border-rounded uk-box-shadow-small"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OnePlusTwoGallery;